import {
  convocatoria001,
  lop1,
} from "../../json/anioInvitaciones/2024/anioInvitacion2024";

export const obtenerDatosSeleccionados = (selectedItemIndex) => {
  let datosSeleccionados = [];

  switch (selectedItemIndex) {
    case "Convocatoria 01-2024":
      datosSeleccionados = convocatoria001;
      break;
    case "CAASIM-HGO-L.O.P.-01-2024":
      datosSeleccionados = lop1;
      break;
    default:
      datosSeleccionados = [];
  }

  return datosSeleccionados;
};
